import React, { useState, useEffect } from "react";
import NavHeader from "../components/navigation/NavHeader";
import Footer from "../components/navigation/Footer";
import GoUpDown from "../components/navigation/GoUpDown";
import CommunityAccordion from "../components/community/CommunityAccordion";
import CommunityAccordionSkeleton from "../components/skeletons/CommunityAccordionSkeleton";
import AsideLeft from "../components/aside/AsideLeft";
import AsideRight from "../components/aside/AsideRight";

import { getAds } from "../core/forum_ads"
import EditIcon from "../components/icons/Edit";
import PlusCircle from "../components/icons/PlusCircle";
import ReactTimeAgo from 'react-time-ago';
import { useNavigate } from "react-router-dom";
import CommunityLayout from "../components/layouts/CommunityLayout";
import { usePageTitle } from '../hooks/usePageTitle';
import { getSessionData } from "../utils/auth";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "";


const ForumAds = () => {
    usePageTitle('Forum Ads - Wefayo');

    const navigate = useNavigate();

    const [ads, setAds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const loggedInUser = getSessionData();
    if (loggedInUser === null || loggedInUser?.role !== "admin") {
        navigate(`/`);
    }

    const handleAddAdClick = (e) => {
        e.preventDefault();
        let addsFunderId = "";
        if (BASE_URL.indexOf("localhost") >= 0 || BASE_URL.indexOf("dev.api") >= 0) {
            addsFunderId = "66aa47ffbe29e5376767aa7f";
        } else {
            addsFunderId = "66aa582f5e73648c3619db01";
        }
        navigate(`/forumads/add/${addsFunderId}`);
    }

    const fetchAds = async () => {
        setIsLoading(true);

        const data = await getAds();
        // console.log("data::", data);
        setAds(data);
        setIsLoading(false);
    }

    useEffect(() => {
        fetchAds();
    }, []);


    return (
        <CommunityLayout currentPage={"forumads"} onCommunitiesLoaded={()=>{}} >
            <div className="flex-grow flex flex-col  ">
                <div className="flex flex-col ">

                    {isLoading &&
                        <>
                            <CommunityAccordionSkeleton></CommunityAccordionSkeleton>
                            <CommunityAccordionSkeleton items={2}></CommunityAccordionSkeleton>
                            <CommunityAccordionSkeleton items={3}></CommunityAccordionSkeleton>
                        </>
                    }
                    {!isLoading &&
                        <div className="mx-auto w-full  mb-20 md:mb-0 relative rounded-md flex flex-col flex-1 " >

                            <div className="flex justify-between items-center bg-primary-white font-bold  rounded-t-md border-b border-gray-200 p-2">
                                <h5 className="text-lg">Forum Ads</h5>
                                <div className="flex flex-row gap-x-2">
                                    {/* <span>All</span>
                                    <span>Active ads</span>
                                    <span>Expired ads</span>
                                    <span>Closed</span> */}

                                    <a
                                        onClick={(e) => handleAddAdClick(e)}
                                        className="pointer flex flex-row gap-x-[2px] cursor-pointer rounded-sm text-purple-900 px-3 py-1.5 text-sm md:text-md font-bold hover:text-purple-800 "
                                    >
                                        <PlusCircle />
                                        Create Ad
                                    </a>
                                </div>
                            </div>

                            <div className="text-sm w-full flex-1 flex flex-col justify-start items-start bg-white">
                                {ads.map((ad, index) => {
                                    return <div className="flex flex-row self-stretch p-1">
                                        <div className="max-w-[200px] cursor-pointer">
                                            <img
                                                className="inline-block rounded-sm "
                                                src={ad?.company_logo??""}
                                                alt=""
                                            />
                                            <br />
                                            <img
                                                className="inline-block rounded-sm "
                                                src={ad.media}
                                                alt=""
                                            />
                                        </div>
                                        <div className="flex flex-col flex-grow p-2">
                                            <div className="h-[80px] md:h-auto flex items-center  flex-col md:flex-row gap-y-2  border-b border-gray-200 ">
                                                <div className="min-w-[100px]">
                                                    Title / Caption
                                                </div>
                                                <div className=" text-md font-bold capitalize p-1">
                                                    {ad.title}
                                                </div>
                                            </div>
                                            <div className="h-[80px] md:h-auto flex items-center  flex-col md:flex-row gap-y-2  border-b border-gray-200 ">
                                                <div className="min-w-[100px]">
                                                    Navigate To
                                                </div>
                                                <div className=" text-md font-bold capitalize p-1">
                                                    <a target="_blank" href={ad.url}>{ad.url}</a>
                                                </div>
                                            </div>
                                            <div className="h-[80px] md:h-auto flex items-center  flex-col md:flex-row gap-y-2  border-b border-gray-200 ">
                                                <div className="min-w-[100px]">
                                                    Date Posted
                                                </div>
                                                <div className=" text-md font-bold capitalize p-1">
                                                    {ad.posted_date}
                                                </div>
                                            </div>
                                            <div className="h-[80px] md:h-auto flex items-center  flex-col md:flex-row gap-y-2  border-b border-gray-200 ">
                                                <div className="min-w-[100px]">
                                                    Date Expired
                                                </div>
                                                <div className=" text-md font-bold capitalize p-1">
                                                    {ad.expiry_date}
                                                </div>
                                            </div>
                                            <div className="h-[80px] md:h-auto flex items-center  flex-col md:flex-row gap-y-2  border-b border-gray-200 ">
                                                <div className="min-w-[100px]">
                                                    Status
                                                </div>
                                                <div className=" text-md font-bold capitalize p-1">
                                                    {ad.status}
                                                </div>
                                            </div>
                                            {/* <div className="h-[80px] md:h-auto flex items-center flex-col md:flex-row gap-y-2  border-b border-gray-200 ">
                                                <div className="min-w-[100px]">
                                                    Added By
                                                </div>
                                                <div className=" text-md font-bold capitalize p-1">
                                                    {ad.user_id}
                                                </div>
                                            </div> */}
                                            <div className="h-[80px] md:h-auto flex items-center flex-col md:flex-row gap-y-2  border-b border-gray-200 ">
                                                <div className="min-w-[100px]">
                                                    Forum Link
                                                </div>
                                                <div className=" text-md font-bold capitalize p-1">
                                                    <a href={ad.forum_id}>{ad.forum_id}</a>
                                                </div>
                                            </div>
                                            <div className="h-[80px] md:h-auto flex items-center flex-col md:flex-row gap-y-2 border-b border-gray-200">
                                                <div className="min-w-[100px]">
                                                    Description
                                                </div>
                                                <div className=" text-md font-bold capitalize p-1">
                                                    {ad.description}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>

                        </div>
                    }
                </div>
            </div>
        </CommunityLayout>
    );
};

export default ForumAds;

